/* /assets/cart-bar.js - Barra flotante de anadir al carrito para Palo Alto 6.2.0 (B-Pets) */
/* v2: incluye sincronizacion de variantes con el formulario principal */
(function () {
  'use strict';
 
  class CartBar extends HTMLElement {
    connectedCallback() {
      // Contenedor del producto y formulario real del tema 6.2.0
      this.productRoot = this.closest('[data-product]') || document;
      this.form = this.productRoot.querySelector('[data-product-form]');
      this.atcReal = this.form ? this.form.querySelector('[data-add-to-cart]') : null;
 
      // Sin formulario o boton real, no hacemos nada (evita errores)
      if (!this.form || !this.atcReal) return;
 
      // Elemento que vigilamos para mostrar/ocultar la barra
      this.anchor =
        this.atcReal.closest('.product__submit__holder') ||
        this.atcReal.closest('.product__submit__item') ||
        this.atcReal;
 
      this.barAtc = this.querySelector('[data-cart-bar-add-to-cart]');
      this.optionSelects = this.querySelectorAll('[data-cart-bar-option]');
      this.barQtyInput = this.querySelector('[data-cart-bar-qty] [data-quantity-field]');
      this.mainQtyInput = this.form.querySelector('[data-quantity-field]');
      this.barPrice = this.querySelector('[data-product-price]');
      this.barImage = this.querySelector('[data-cart-bar-image] img');
      this.productSelect = this.form.querySelector('[data-product-select]');
      this.productData = this.getProductData();
 
      this.bindEvents();
      this.initObserver();
    }
 
    getProductData() {
      try {
        var node =
          this.productRoot.querySelector('[data-product-json]') ||
          document.querySelector('[data-product-json]');
        return node ? JSON.parse(node.textContent) : null;
      } catch (e) {
        return null;
      }
    }
 
    bindEvents() {
      // Boton de la barra -> dispara el boton real del formulario (respeta Zafepay)
      if (this.barAtc) {
        this.barAtc.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.atcReal.hasAttribute('disabled')) return;
          this.syncQtyToMain();
          this.barAtc.classList.add('is-loading');
          this.barAtc.setAttribute('disabled', 'disabled');
          this.atcReal.click();
          setTimeout(() => {
            this.barAtc.classList.remove('is-loading');
            this.barAtc.removeAttribute('disabled');
          }, 2500);
        });
      }
 
      // Cambio de variante en la barra -> reflejar en el formulario real
      this.optionSelects.forEach((sel) => {
        sel.addEventListener('change', () => this.onBarOptionChange(sel));
      });
 
      // Sincronizacion de cantidad en ambos sentidos
      if (this.barQtyInput && this.mainQtyInput) {
        this.barQtyInput.addEventListener('change', () => this.syncQtyToMain());
        this.mainQtyInput.addEventListener('change', () => this.syncQtyToBar());
      }
    }
 
    onBarOptionChange(sel) {
      var index = sel.getAttribute('data-index'); // "optionN"
      var value = sel.value;
      this.applyOptionToForm(index, value);
      // Dar tiempo a que el tema actualice precio/imagen/id y luego refrescar la barra
      setTimeout(() => this.refreshBar(), 300);
    }
 
    applyOptionToForm(index, value) {
      // 1) Radios o swatches reales (variants_style = boxes / swatches)
      var radios = this.form.querySelectorAll(
        'input[type="radio"][data-single-option-selector][data-index="' + index + '"]'
      );
      if (radios.length) {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === value) {
            radios[i].checked = true;
            radios[i].click();
            return;
          }
        }
        return;
      }
 
      // 2) Desplegable (popout-select)
      var hidden = this.form.querySelector(
        '[data-popout-input][data-single-option-selector][data-index="' + index + '"]'
      );
      if (hidden) {
        var popout = hidden.closest('popout-select');
        var opt = popout
          ? popout.querySelector('[data-popout-option][data-value="' + this.cssEscape(value) + '"]')
          : null;
        if (opt) {
          opt.click();
          return;
        }
        // Respaldo: setear valor y avisar
        hidden.value = value;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
 
    cssEscape(v) {
      return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"');
    }
 
    refreshBar() {
      // Precio: copiar el del bloque principal del producto (excluyendo la propia barra)
      var prices = this.productRoot.querySelectorAll('.product__price [data-product-price]');
      var mainPrice = null;
      for (var i = 0; i < prices.length; i++) {
        if (!prices[i].closest('cart-bar')) {
          mainPrice = prices[i];
          break;
        }
      }
      if (this.barPrice && mainPrice) {
        this.barPrice.innerHTML = mainPrice.innerHTML;
        this.barPrice.classList.toggle(
          'product__price--sale',
          mainPrice.classList.contains('product__price--sale')
        );
      }
 
      // Disponibilidad: reflejar el estado del boton real
      if (this.barAtc) {
        this.barAtc.toggleAttribute('disabled', this.atcReal.hasAttribute('disabled'));
      }
 
      // Imagen: actualizar segun la variante seleccionada
      this.updateImage();
    }
 
    updateImage() {
      if (!this.barImage || !this.productData || !this.productSelect) return;
      var id = parseInt(this.productSelect.value, 10);
      var variants = this.productData.variants || [];
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) {
          variant = variants[i];
          break;
        }
      }
      var src = variant && variant.featured_image ? variant.featured_image.src : null;
      if (src) {
        this.barImage.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      }
    }
 
    syncQtyToMain() {
      if (this.barQtyInput && this.mainQtyInput && this.barQtyInput.value) {
        this.mainQtyInput.value = this.barQtyInput.value;
        this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
 
    syncQtyToBar() {
      if (this.barQtyInput && this.mainQtyInput && this.mainQtyInput.value) {
        this.barQtyInput.value = this.mainQtyInput.value;
      }
    }
 
    initObserver() {
      if (!('IntersectionObserver' in window) || !this.anchor) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            var passedTop = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', passedTop);
          });
        },
        { rootMargin: '0px', threshold: 0 }
      );
      this.observer.observe(this.anchor);
    }
 
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
 
  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
})();